export default __webpack_public_path__ + "static/media/e_commerce.f81195ad.svg";